import { orchestrator } from 'satcheljs';
import { formatSavedViews } from '../actions/privateActions';
import { removeInactiveCalendarIds } from '../utils/saveCalendarViewUtils';
import { editSavedCalendarView } from '../actions/publicActions';
import { updateStoreFromOws } from '../mutators/updateStoreFromOwsMutator';
import { addUpdatedSavedViewIds } from '../mutators/addUpdatedSavedViewIdsMutator';

orchestrator(formatSavedViews, actionMessage => {
    const { savedViews } = actionMessage;
    savedViews.forEach(savedView => {
        const removedIdsResult = removeInactiveCalendarIds(savedView.selectedCalendarIds);
        if (removedIdsResult.hasUpdated) {
            savedView.selectedCalendarIds = removedIdsResult.updatedCalendarIds;
            editSavedCalendarView(savedView);
            addUpdatedSavedViewIds(savedView.id);
        }
    });
    updateStoreFromOws(savedViews);
});
